import { set, sum } from "lodash";
import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { useForm } from "react-hook-form";
import { Bar } from "react-chartjs-2";
//import Input from "components/shared/Inputs/Inputs";
import SelectList from "components/shared/select/select";
import MetaTags from "react-meta-tags";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Swal from "sweetalert2";
import api from "../../services/api";
import "../../assets/icons/svg/_svg_icons.scss";
import ConsumoEmpresaDetalhe from "./ConsumoEmpresaDetalhe";
import logos from "../../assets/images/logo_padrao_alinhado.png"


const ConsumoEmpresa = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <React.Fragment>
      <i
        className="dripicons-expand"
        style={{
          position: "fixed",
          top: 70,
          right: '4px',
          zIndex: 1050,
          fontSize: 18,
          color: '#0d6efd',
          background: '#fff',
          borderRadius: '50%',
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
          padding: 5,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        tabIndex={0}
        aria-label="Tela cheia"
        onClick={openModal}
        onKeyDown={(e) => {
          if (e.key === 'Escape') closeModal(false);
        }}
      />
      <div style={{ position: 'relative', width: '100%' }}>


        {!modalOpen &&
            <ConsumoEmpresaDetalhe />
        }
      </div>
      <Modal
        isOpen={modalOpen}
        toggle={closeModal}
        fullscreen
        style={{
          minHeight: '100vh',
          minWidth: '100vw',
          display: 'block',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
          padding: 0,
          overflow: 'hidden'
        }}
      >
        <ModalBody
          style={{
            minHeight: '99.8vh',
            display: 'block',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0,
            padding: 0,
            overflow: 'hidden'
          }}
        >
          <button
            className="btn btn-danger"
            onClick={closeModal}
            style={{
              position: 'absolute',
              right: '40px',
              top: '20px',
              cursor: 'pointer',
              zIndex: 10000
            }}
            type="button">Fechar</button>
                      <div style={{ marginTop: '-50px' }}>

          <ConsumoEmpresaDetalhe />
          </div>
         {/* <div
            style={{
              position: 'fixed',
              left: 0,
              bottom: '35px',
              width: '100%',
              background: 'rgba(255,255,255,0.95)',
              zIndex: 10001,
              textAlign: 'center',
              padding: '8px 0',
            }}
          >
            <img src={logos} alt="" height="50" style={{ position: 'relative', top: '-5px' }} />
            <div>© {new Date().getFullYear()} DMAE</div>
          </div>*/}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ConsumoEmpresa;
